import { render, staticRenderFns } from "./Laborer.vue?vue&type=template&id=637b130f&scoped=true&"
import script from "./Laborer.vue?vue&type=script&lang=js&"
export * from "./Laborer.vue?vue&type=script&lang=js&"
import style0 from "./Laborer.vue?vue&type=style&index=0&id=637b130f&lang=less&scoped=true&"
import style1 from "./Laborer.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637b130f",
  null
  
)

export default component.exports